module.exports = __webpack_public_path__ + "static/img/big001.ef5b1ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big001.png
// module id = z7Cw
// module chunks = 1